import script from "./ChatMessageComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatMessageComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ChatMessageComponent.vue?vue&type=style&index=0&id=a73c6d2a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a73c6d2a"]])

export default __exports__